import React, { useEffect, useState, useRef } from "react";
import { Link, useLocation } from "react-router-dom";
import {
  admin_sidebar,
  supper_admin_sidebar,
  sub_admin_sidebar,
  Client,
} from "./Nav_Config";
import { Get_Sub_Admin_Permissions } from "../../../ReduxStore/Slice/Subadmin/Subadminslice";
import $ from "jquery";
import { useDispatch } from "react-redux";
import Logo from "./Logo";
import { Get_Company_Logo } from "../../../ReduxStore/Slice/Admin/AdminSlice";
import { permissionToSidebarMap } from "./SubadminPermission";
import { GetAdminPermission } from "../../../Service/admin.service";

const SidebarItem = ({ item }) => {
  const location = useLocation();
  const currentPath = location.pathname;
  const hasSubItems = item.Data?.length > 0;

  const isItemActive = currentPath === item.route;

  const isAnySubItemActive =
    hasSubItems && item.Data.some((sub) => currentPath === sub.route);
  const handleLinkClick = () => {
    if (document.body.classList.contains("sidebar-open")) {
      document.body.classList.remove("sidebar-open");
      document.body.classList.add("sidebar-remove");
    }
  };

  if (hasSubItems) {
    return (
      <li className={isAnySubItemActive ? "mm-active" : ""}>
        <a href="#!" className="has-arrow" aria-expanded={isAnySubItemActive}>
          {typeof item.Icon === "string" ? <i className={item.Icon}></i> : <item.Icon size={20} strokeWidth={2} style={{ marginRight: "10px", marginTop: "-3px" }} />}
          <span className="nav-text">{item.name}</span>
        </a>
        <ul className={`mm-collapse ${isAnySubItemActive ? "mm-show" : ""}`}>
          {item.Data.map((sub, idx) => {
            const isActive = currentPath === sub.route;
            return (
              <li key={idx} className={isActive ? "mm-active" : ""}>
                <Link
                  to={sub.route}
                  className={isActive ? "active" : ""}
                  onClick={handleLinkClick}
                >
                  {typeof sub.Icon === "string" ? <i className={sub.Icon}></i> : <sub.Icon size={16} strokeWidth={2} style={{ marginRight: "8px" }} />} {sub.name}
                </Link>
              </li>
            );
          })}
        </ul>
      </li>
    );
  }

  return (
    <li className={isItemActive ? "mm-active" : ""}>
      <Link
        to={item.route}
        className={isItemActive ? "active sidebar-link" : "sidebar-link "}
        onClick={handleLinkClick}
      >
        {typeof item.Icon === "string" ? <i className={item.Icon}></i> : <item.Icon size={20} strokeWidth={2} style={{ marginRight: "10px", marginTop: "-3px" }} />}
        <span className="nav-text">{item.name}</span>
      </Link>
    </li>
  );
};

const Sidebar = () => {
  const [getLogo, setLogo] = useState("");
  const dispatch = useDispatch();
  const sidebarRef = useRef(null);
  const [permissions, setPermissions] = useState([]);
  const user_details = JSON.parse(localStorage.getItem("user_details"));
  const user_details_goTo = JSON.parse(
    localStorage.getItem("user_details_goTo")
  );
  const gotodashboard = JSON.parse(localStorage.getItem("gotodashboard"));
  const backtestPermission = localStorage.getItem("backtestPermission");

  const userData = {
    roles: JSON.parse(localStorage.getItem("user_role")),

    gotodashboard: JSON.parse(localStorage.getItem("gotodashboard")),
    userRoleGoTo: JSON.parse(localStorage.getItem("user_role_goTo")),
    userRoleGoTo: JSON.parse(localStorage.getItem("user_role_goTo")),

    userId: JSON.parse(localStorage.getItem("user_details"))?.user_id,
    token: JSON.parse(localStorage.getItem("user_details"))?.token,
    goToUserId: JSON.parse(localStorage.getItem("user_details_goTo")),
  };

  // 🔥 Updated Function
  const GetSubAdminPermisson = async () => {
    await dispatch(
      Get_Sub_Admin_Permissions({
        id: gotodashboard ? user_details_goTo?.user_id : user_details?.user_id,
      })
    )
      .unwrap()
      .then((response) => {
        if (response?.status) {
          const data = response.data[0] || {};

          localStorage.setItem("subadminpermission", JSON.stringify(data));
          
          const allowedSidebars = permissionToSidebarMap
            .filter((mapItem) => data[mapItem.permission] === 1)
            .map((mapItem) => mapItem.sidebar);

          if (!allowedSidebars.includes("Dashboard")) {
            allowedSidebars.unshift("Dashboard");
          }
          // if (!allowedSidebars.includes("Strategies")) {
          //   allowedSidebars.unshift("Strategies");
          // }
          // if (!allowedSidebars.includes("Stock Group Services")) {
          //   allowedSidebars.unshift("Stock Group Services");
          // }

          allowedSidebars.unshift("All Clients");

          setPermissions(allowedSidebars);
        }
      });
  };

  const CompanyName = async () => {
    try {
      const response = await dispatch(Get_Company_Logo()).unwrap();
      if (response?.status) {
        const data = response?.data?.[0];
        setLogo(data?.logo);

        localStorage.setItem("watermark", data?.watermark);

        $("body").removeClass().addClass(data.theme_name);
        $(".brand-title").attr("src", data?.logo);
        $(".Company_logo").html(data?.panel_name);
        $(".watermarkId").css({
          "background-image": `url(${data?.watermark})`,
        });
      }
    } catch (error) {
      console.error("Error fetching company logo:", error);
    }
  };

  const GetAdminPermission1 = async () => {
    try {
      const response = await GetAdminPermission();
      if (response?.status) {
        const data = response?.data || [];
        const permissions = {
          Addclient: data[0]?.Addclient,
          Create_Strategy: data[0]?.Create_Strategy,
          Two_day_client: data[0]?.Two_day_client,
          invoice_Permission: data[0]?.invoice_Permission,
          live_price: data[0]?.live_price,
          broker_id: data[0]?.broker_id,
          isActive: data[0]?.isActive,
          LoginPage: data[0]?.LoginPage,
          trade_History_DeltaExchange: data[0]?.trade_History_DeltaExchange,
          updatedatefilterpermission: data[0]?.Datefilterpermission,
        
        };

        localStorage.setItem("permission", JSON.stringify(permissions));
      }
    } catch (error) {
      console.error("Error fetching admin permissions:", error);
    }
  };

  useEffect(() => {
    CompanyName();
    GetSubAdminPermisson();
    GetAdminPermission1();
  }, []);

  useEffect(() => {
    const handleClickOutside = (e) => {
      const clickedInside = sidebarRef.current?.contains(e.target);
      const toggleBtnClicked = document
        .querySelector(".toggle-sidebar-btn")
        ?.contains(e.target);

      if (
        document.body.classList.contains("sidebar-open") &&
        !clickedInside &&
        !toggleBtnClicked
      ) {
        document.body.classList.remove("sidebar-open");
        document.body.classList.add("sidebar-remove");
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  const getSidebarConfig = () => {
    const { roles, gotodashboard, userRoleGoTo } = userData;

    const effectiveRole = gotodashboard && userRoleGoTo ? userRoleGoTo : roles;

    switch (effectiveRole) {
      case "SUPERADMIN":
        return { config: supper_admin_sidebar, role: "SUPERADMIN" };

      case "ADMIN":
        return { config: admin_sidebar, role: "ADMIN" };

      case "SUBADMIN":
        return { config: sub_admin_sidebar, role: "SUBADMIN" };

      case "USER":
        return { config: Client, role: "USER" };

      default:
        return { config: [], role: null };
    }
  };

  const { config: sidebarConfig, role: currentRole } = getSidebarConfig();

  const filteredSidebar =
    currentRole === "SUBADMIN"
      ? sidebarConfig.filter((item) => permissions.includes(item.name))
      : sidebarConfig;

  return (
    <div className="deznav" ref={sidebarRef}>
      <div className="deznav-scroll">
        <Logo data={getLogo} />
        <ul className="metismenu" id="menu">
          {filteredSidebar?.map((item, index) => {
            if (item.name === "Backtesting" && backtestPermission == 0) {
              return null; // skip this item
            }

            return (
              <SidebarItem
                key={item.id || index}
                item={item}
                permissions={permissions}
                userRole={currentRole}
              />
            );
          })}
        </ul>
      </div>
    </div>
  );
};

export default Sidebar;
